import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarClock, Users, LogOut, Monitor, History } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import SubstitutionsPanel from "@/components/SubstitutionsPanel";
import TeachersPanel from "@/components/TeachersPanel";
import HistoryPanel from "@/components/HistoryPanel";
import UnconfirmedAlerts from "@/components/UnconfirmedAlerts";
import ProfileSettings from "@/components/ProfileSettings";

export default function Admin() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("subs");

  const nav = [
    { key: "subs", label: "Sostituzioni", icon: CalendarClock },
    { key: "teachers", label: "Docenti", icon: Users },
    { key: "history", label: "Storico", icon: History },
  ];

  return (
    <div className="min-h-screen flex bg-secondary/40">
      <aside className="w-64 shrink-0 border-r border-border bg-background flex flex-col">
        <div className="flex items-center gap-3 px-6 py-6 border-b border-border">
          <div className="flex h-10 w-10 items-center justify-center rounded-md bg-white border border-border overflow-hidden">
            <img src="/logo.png" alt="Logo I.T.E. Alfonso Gallo" className="h-full w-full object-contain" data-testid="admin-logo" />
          </div>
          <div className="leading-tight">
            <p className="font-heading font-bold text-sm">Alfonso Gallo</p>
            <p className="text-xs text-muted-foreground">Sostituzioni</p>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {nav.map((n) => {
            const Icon = n.icon;
            const active = tab === n.key;
            return (
              <button
                key={n.key}
                data-testid={`nav-${n.key}`}
                onClick={() => setTab(n.key)}
                className={`w-full flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium transition-colors ${
                  active ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-accent"
                }`}
              >
                <Icon className="h-4 w-4" /> {n.label}
              </button>
            );
          })}
          <button
            data-testid="nav-tv"
            onClick={() => window.open("/tv", "_blank")}
            className="w-full flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium text-muted-foreground hover:bg-accent transition-colors"
          >
            <Monitor className="h-4 w-4" /> Schermata TV
          </button>
        </nav>
        <div className="p-3 border-t border-border">
          <p className="px-3 py-1 text-xs text-muted-foreground truncate">{user?.name ? `${user.name} · ` : ""}{user?.email}</p>
          <ProfileSettings />
          <Button
            variant="ghost"
            data-testid="logout-button"
            onClick={() => { logout(); navigate("/login"); }}
            className="w-full justify-start gap-3 text-muted-foreground"
          >
            <LogOut className="h-4 w-4" /> Esci
          </Button>
        </div>
      </aside>

      <main className="flex-1 overflow-auto">
        <UnconfirmedAlerts />
        <div className="p-6 lg:p-8 max-w-6xl">
          {tab === "subs" && <SubstitutionsPanel />}
          {tab === "teachers" && <TeachersPanel />}
          {tab === "history" && <HistoryPanel />}
        </div>
      </main>
    </div>
  );
}
